(() => {
  function enhance(root=document){
    const menu=root.querySelector('.ss-mobile-menu');
    if(menu&&!menu.dataset.ready){menu.dataset.ready='true';menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.open=false;}));}
    const body=root.querySelector('[data-article-body]');
    if(body&&!body.dataset.enhanced){
      body.dataset.enhanced='true';
      const headings=[...body.querySelectorAll('h2')].filter(h=>h.textContent.trim());
      const toc=root.querySelector('.ss-toc');
      if(toc&&headings.length>=4){
        const nav=toc.querySelector('nav');
        headings.forEach((h,i)=>{if(!h.id)h.id='article-section-'+(i+1);const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;nav.append(a);});
        toc.hidden=false;
        if(matchMedia('(max-width:749px)').matches)toc.querySelector('details').open=false;
      }
      body.querySelectorAll('iframe').forEach(frame=>{if(!frame.title)frame.title='Embedded media';frame.loading='lazy';});
      body.querySelectorAll('img').forEach(img=>{const after=img.parentElement.tagName==='A'?img.parentElement.nextElementSibling:img.nextElementSibling;if(after&&['P','FIGCAPTION'].includes(after.tagName)&&/^(Image|Photo|Photograph|Credit|Source):/i.test(after.textContent.trim())&&!after.querySelector('img'))after.classList.add('ss-caption');});
    }
    const search=root.querySelector('[data-site-search]');
    if(search&&!search.dataset.enhanced){
      search.dataset.enhanced='true';
      const form=search.querySelector('form'),input=form.querySelector('[name=q]'),local=search.querySelector('[data-local-results]'),grid=local.querySelector('.ss-search-grid'),status=local.querySelector('[role=status]'),more=local.querySelector('[data-more]');
      const onlyBooks=new URLSearchParams(location.search).get('type')==='product';
      if(onlyBooks)form.querySelector('[name=type]').value='product';
      const normalize=s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      let entries=[],matches=[],shown=24;
      function render(){
        grid.replaceChildren();
        status.textContent=matches.length+' '+search.dataset.resultsLabel;
        if(!matches.length){const p=document.createElement('p');p.textContent=search.dataset.emptyLabel;grid.append(p);}
        matches.slice(0,shown).forEach(item=>{
          const card=document.createElement('article');card.className='ss-result';
          const type=document.createElement('p');type.className='ss-eyebrow';type.textContent=search.dataset[item.type+'Label'];
          const title=document.createElement('h2'),link=document.createElement('a');link.href=item.url;link.textContent=item.title;title.append(link);
          card.append(type,title);
          const text=item.type==='book'?item.author:item.excerpt;
          if(text){const p=document.createElement('p');p.textContent=text;card.append(p);}
          grid.append(card);
        });
        more.hidden=shown>=matches.length;
      }
      function filter(){
        const terms=normalize(input.value).trim().split(/\s+/).filter(Boolean);
        if(!terms.length){local.hidden=true;return;}
        matches=entries.filter(item=>(!onlyBooks||item.type==='book')&&terms.every(t=>item.haystack.includes(t))).sort((a,b)=>{
          const score=x=>terms.reduce((sum,t)=>sum+(normalize(x.title+' '+(x.author||'')).includes(t)?1:0),0);
          return score(b)-score(a);
        });shown=24;local.hidden=false;render();
      }
      fetch(search.dataset.indexUrl,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('Search unavailable');return r.text();}).then(text=>{
        const parsed=JSON.parse(text);entries=parsed.map(item=>({...item,haystack:normalize(item.title+' '+(item.author||'')+' '+(item.text||''))}));
        search.querySelector('[data-native-results]').hidden=true;filter();
        form.addEventListener('submit',event=>{event.preventDefault();const url=new URL(location.href);url.search='';url.searchParams.set('q',input.value);url.searchParams.set('type',onlyBooks?'product':'product,article,page');history.pushState({},'',url);filter();});
        let timer;input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(filter,180);});
        more.addEventListener('click',()=>{shown+=24;render();});
        addEventListener('popstate',()=>{input.value=new URLSearchParams(location.search).get('q')||'';filter();});
      }).catch(()=>{/* Native Shopify search remains available if the index cannot load. */});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>enhance());else enhance();
  document.addEventListener('shopify:section:load',()=>enhance());
})();
